var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElapsedGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \n\t.st0{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;}\n\t.st2{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 50c11.4-7.2 19.2-21.2 19.2-37.2 0-1.8-0.1-3.6-0.3-5.3H13.1c-0.2 1.7-0.3 3.5-0.3 5.3 0 16 7.7 29.9 19.2 37.2 -11.4 7.2-19.2 21.2-19.2 37.2 0 1.8 0.1 3.6 0.3 5.3h73.8c0.2-1.7 0.3-3.5 0.3-5.3C87.2 71.2 79.4 57.2 68 50zM20.8 87.2c0-15.5 6.7-28.7 18.6-33v-8.3l0 0c-11.9-4.3-18.6-17.5-18.6-33l0 0h58.4l0 0c0 15.5-6.7 28.7-18.6 33v8.3c11.9 4.3 18.6 17.5 18.6 33H20.8zM58.9 63.1c-5.9-3.4-6.3-7.8-6.3-10.4v-5.3c0-2.7 0.3-7 6.3-10.4 3.2-1.9 6-4.7 8.1-8.2H33c2.1 3.5 4.9 6.3 8.1 8.2 5.9 3.4 6.3 7.8 6.3 10.4l0 5.3c0 2.7-0.3 7-6.3 10.4 -6 3.5-10.5 10.4-11.9 18.8h41.6C69.5 73.5 65 66.6 58.9 63.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElapsedGate);
export default __webpack_public_path__ + "static/media/elapsed-gate.6f0dd81411350681d3921395a9b56fda.svg";
export { ForwardRef as ReactComponent };